import React, { useMemo } from 'react';
import MirsTable from 'components/general/table/Table.js';
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { OverallColumns } from '../components/Columns';
import NotAvailable from 'components/common/NotAvailable';
import { isStartListStatus, isFinishedStatus, isLiveStatus } from 'helpers/status';
import CaptionTable from 'components/general/table/CaptionTable';
import Status from 'components/presentation/Status';
import SalRaceIncidents from "components/sports/sal/views/SalRaceIndicidents";
import { isFinals } from '../helper/SalHelpers';


const SalOverallResults = ({ data, dataUnits, races = []}) => {
    const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()

    const { breakPoint } = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 
    //console.log(data);

    const type = data?.cumulativeResults?.results?.length > 0 ? data?.cumulativeResults.results[0].competitorType : '';
    const mirsColumns = useMemo(() => OverallColumns(type, races), []);
  
    const resultStatus = data?.results?.status?.code;
  
    const isStartList = isStartListStatus(resultStatus);
    const isFinished = isFinishedStatus(resultStatus);
    const isLive = isLiveStatus(resultStatus)

    const hasQualMark = data?.cumulativeResults?.results?.find(res => res?.qualificationMark)
   
    if (!data?.cumulativeResults?.results) return <NotAvailable />;
  
    const getHiddenColumns = () => {
      const finishedHidden = isFinished ? [] : []
      const startListHidden = isStartList ? [] : []
      const mobileHidden = isMobile ? [...races?.map(r => 'Race' + r?.pos)] : []
      const qualMark = hasQualMark ? [] : ['QualMark']
      return [...finishedHidden, ...startListHidden, ...mobileHidden, ...qualMark];
    }
  
  
    const caption = (
      <CaptionTable
        leftCol={<span className="fw-bold"><Label data="HeaderOverallResults" /></span>}
       />
    );
  
    return (
      <>    
        <MirsTable
          id={`mirs-table-results-${mirs_rsc}`}
          caption={caption}
          data={data?.cumulativeResults?.results}
          columns={mirsColumns}
          keyRow={"participant-code"}
          initialSortBy={[{ id: 'Rank', desc: false }]}
          hiddenColumns={getHiddenColumns()}
        />
      </>
    );
  
}

export default SalOverallResults;